// DEPRECATED - Attribution journey was based on leads table which is no longer used.
// Kept for API compatibility. Returns null.
import { useQuery } from "@tanstack/react-query";

export interface TouchpointEvent {
  created_at: string;
  touchpoint_channel: string;
  funnel_stage: string;
  action_type: string;
}

export interface AttributionJourney {
  lead_id: string;
  lead_name: string;
  product_name: string;
  became_customer: boolean;
  deal_value: number;
  attribution_window_days: number;
  first_touch: {
    ad_id: string;
    campaign: string;
    funnel_stage: string;
  };
  last_touch: {
    ad_id: string;
    campaign: string;
    funnel_stage: string;
  };
  journey: TouchpointEvent[];
}

// DEPRECATED - Returns null. Attribution journey was based on leads table.
export function useAttributionJourney(_leadId: string | null) {
  return useQuery({
    queryKey: ['attribution-journey', _leadId],
    queryFn: async () => {
      // DEPRECATED - leads table no longer used
      console.warn('[DEPRECATED] useAttributionJourney called - leads table deprecated');
      return null;
    },
    enabled: !!_leadId,
  });
}
